import {
  FiGrid, FiHome, FiUsers, FiCalendar, FiEye,
  FiDollarSign, FiBell, FiFileText, FiZap,
  FiTool, FiUserPlus, FiMessageSquare, FiCopy, FiClock, FiThumbsUp,
  FiShield, FiSettings
} from 'react-icons/fi';

export const TAB_SECTIONS = [
  { key: 'dashboard', label: 'Dashboard', path: '/', icon: FiGrid },
  { key: 'properties', label: 'Properties', path: '/properties', icon: FiHome },
  { key: 'financials', label: 'Financials', path: '/financials', icon: FiDollarSign },
  { key: 'operations', label: 'Operations', path: '/operations', icon: FiTool },
  { key: 'admin', label: 'Admin', path: '/admin', icon: FiShield },
];

export const SECTION_LINKS = {
  properties: [
    { to: '/properties', label: 'Portfolio', icon: FiHome, end: true },
    { to: '/properties/tenants', label: 'Tenants', icon: FiUsers },
    { to: '/properties/calendar', label: 'Calendar', icon: FiCalendar },
    { to: '/properties/visits', label: 'Visits', icon: FiEye },
  ],
  financials: [
    { to: '/financials', label: 'Overview', icon: FiDollarSign, end: true },
    { to: '/financials/reminders', label: 'Reminders', icon: FiBell },
    { to: '/financials/reports', label: 'Reports', icon: FiFileText },
    { to: '/financials/utilities', label: 'Utilities', icon: FiZap },
  ],
  operations: [
    { to: '/operations', label: 'Maintenance', icon: FiTool, end: true },
    { to: '/operations/onboarding', label: 'Onboarding', icon: FiUserPlus },
    { to: '/operations/communications', label: 'Comms', icon: FiMessageSquare },
    { to: '/operations/templates', label: 'Templates', icon: FiCopy },
    { to: '/operations/expirations', label: 'Expirations', icon: FiClock },
    { to: '/operations/feedback', label: 'Feedback', icon: FiThumbsUp },
  ],
  admin: [
    { to: '/admin', label: 'Access Logs', icon: FiShield, end: true },
    { to: '/admin/settings', label: 'Settings', icon: FiSettings },
  ],
};
